import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import { defineComponent, reactive, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useState } from "@/hooks/mapGet/index.js";
import { useStore } from "vuex";
import Loading from "@/baseui/loading/loading.vue";
import ListDetailTop from "@/components/list-detail/listDetailTop.vue";
import ListDetailNav from "@/components/list-detail/listDetailNav.vue";
import ArtistListDetail from "@/components/list-detail/artistListDetail.vue";
import VideoList from "@/components/video-list/videoList.vue";
import ArtistSyno from "./cpns/artistSyno.vue";
export default defineComponent({
  name: "ArtistDetail",
  setup: function setup() {
    var route = useRoute();
    var store = useStore();
    var state = useState("Detail", ["artistDetail"]);
    /* 导航列表 */

    var navList = reactive(["热门50首", "MV", "歌手详情"]);
    var isShow = ref(0); // store.dispatch("Detail/getArtistDetail", route.params.id);
    // store.dispatch("Detail/getArtistAlbum", route.params.id);
    // store.dispatch("Detail/getArtistMv", route.params.id);
    // store.dispatch("Detail/getArtistDesc", route.params.id);

    /* 标题点击事件 */

    var titleClick = function titleClick(index) {
      isShow.value = index;
    };
    /* 当路由id变化则重新请求数据 */


    watch(function () {
      return route.params.id;
    }, function () {
      if (route.path.indexOf("/main/artistdetail") !== -1) {
        store.dispatch("Detail/getArtistDetail", route.params.id);
        store.dispatch("Detail/getArtistAlbum", route.params.id);
        store.dispatch("Detail/getArtistMv", route.params.id);
        store.dispatch("Detail/getArtistDesc", route.params.id);
      }
    }, {
      immediate: true
    });
    return _objectSpread(_objectSpread({
      isShow: isShow,
      route: route
    }, state), {}, {
      navList: navList,
      titleClick: titleClick
    });
  },
  components: {
    Loading: Loading,
    ListDetailTop: ListDetailTop,
    ListDetailNav: ListDetailNav,
    ArtistListDetail: ArtistListDetail,
    VideoList: VideoList,
    ArtistSyno: ArtistSyno
  }
});